import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MESSAGES } from '@shared/constants';
import { ListActions, ToastType } from '@shared/enums';

@Injectable({
	providedIn: 'root'
})
export class ToHttpHeadersService {
	transform(type: string, message: string) {
		const headers = new HttpHeaders().set('X-Toast-Message', message).set('X-Toast-Type', type);

		return { headers };
	}

	generateHeaders(action: ListActions, label: string): { headers: HttpHeaders } {
		const successMessages: Record<ListActions, string> = {
			[ListActions.CREATE]: MESSAGES.SUCCESS_CREATE.replace('{$1}', label),
			[ListActions.UPDATE]: MESSAGES.SUCCESS_UPDATE.replace('{$1}', label),
			[ListActions.DELETE]: MESSAGES.SUCCESS_DELETE.replace('{$1}', label)
		};

		return this.transform(ToastType.SUCCESS, successMessages[action]);
	}

}
